var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sun",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.994,
    y: 58.921,
    transform: "matrix(0.3827 0.9239 -0.9239 0.3827 168.6176 -118.5145)",
    width: 40.001,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 164.979,
    transform: "matrix(0.9239 0.3827 -0.3827 0.9239 71.29 -12.4346)",
    width: 40.001,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.947,
    y: 315.048,
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -118.531 50.2116)",
    width: 40.001,
    height: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.966,
    y: 409.112,
    transform: "matrix(-0.9238 -0.3828 0.3828 -0.9238 168.4872 891.7491)",
    width: 16,
    height: 39.999
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303.031,
    y: 421.036,
    transform: "matrix(-0.3827 -0.9239 0.9239 -0.3827 50.2758 891.6655)",
    width: 40.001,
    height: 16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 409.088,
    y: 315.018,
    transform: "matrix(-0.9239 -0.3827 0.3827 -0.9239 701.898 785.6559)",
    width: 40.001,
    height: 16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 409.054,
    y: 165.011,
    transform: "matrix(-0.9239 0.3827 -0.3827 -0.9239 891.6585 168.6574)",
    width: 40.001,
    height: 16
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 315.001,
    y: 46.895,
    transform: "matrix(0.9238 0.3828 -0.3828 0.9238 50.212 -118.5529)",
    width: 16,
    height: 39.999
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248,88c-88.224,0-160,71.776-160,160s71.776,160,160,160s160-71.776,160-160S336.224,88,248,88z M248,392 c-79.4,0-144-64.6-144-144s64.6-144,144-144s144,64.6,144,144S327.4,392,248,392z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    width: 16,
    height: 72
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 62.097,
    y: 90.096,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 98.0963 -40.6334)",
    width: 71.999,
    height: 16
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    y: 240,
    width: 72,
    height: 16
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 90.091,
    y: 361.915,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -113.9157 748.643)",
    width: 16,
    height: 71.999
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 424,
    width: 16,
    height: 72
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 361.881,
    y: 389.915,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 397.8562 960.6281)",
    width: 71.999,
    height: 16
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 240,
    width: 72,
    height: 16
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 389.911,
    y: 62.091,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 185.9067 -252.6357)",
    width: 16,
    height: 71.999
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/Sun.681607dcda2a01539a9a8a157ae74e6e.svg";
export { ForwardRef as ReactComponent };